const AUDIT_KEY = 'oem_recording_audit'
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000  // 30 days — matches S3 lifecycle

export interface AuditEntry {
  filename: string
  md5: string
  uploaded_at: string   // ISO
  call_log_id: number
}

function load(): AuditEntry[] {
  try {
    const raw = localStorage.getItem(AUDIT_KEY)
    if (!raw) return []
    const entries: AuditEntry[] = JSON.parse(raw)
    const cutoff = Date.now() - MAX_AGE_MS
    return entries.filter(e => new Date(e.uploaded_at).getTime() > cutoff)
  } catch {
    return []
  }
}

function save(entries: AuditEntry[]): void {
  try {
    localStorage.setItem(AUDIT_KEY, JSON.stringify(entries))
  } catch { /* storage full — non-critical */ }
}

export function getAuditLog(): AuditEntry[] {
  return load()
}

export function isAlreadyUploaded(md5: string): boolean {
  return load().some(e => e.md5 === md5)
}

export function addAuditEntry(entry: AuditEntry): void {
  const entries = load()
  // Replace if same filename exists (re-upload of same file with new call_log_id)
  const idx = entries.findIndex(e => e.filename === entry.filename)
  if (idx >= 0) entries[idx] = entry
  else entries.push(entry)
  save(entries)
}
